export default __webpack_public_path__ + "0f802e71128379cc9061ca34db0246ff.jpg";